import axios from "axios";
import { Dispatch } from "redux";
import Url from "../../ApiConfig";
import { GetJudgingSecondRoundDetailsListActionTypes } from "./ActionTypes";
import { GetJudgingSecondRoundDetailsListBody, GetJudgingSecondRoundDetailsListDetails } from "./Model";
import {
  getJudgingSecondRoundDetailsListAPIResClearAction,
  getJudgingSecondRoundDetailsListErrorAction,
  getJudgingSecondRoundDetailsListLoadingAction,
  getJudgingSecondRoundDetailsListSuccessAction,
  getJudgingSecondRoundDetailsListAPIMsgAction,
} from "./Actions";
import { headers } from "../../component/Utility";

let apiRes = {} as GetJudgingSecondRoundDetailsListDetails;
export const getJudgingSecondRoundDetailsList = (
  competionId: GetJudgingSecondRoundDetailsListBody,
) => {
  return function (dispatch: Dispatch<GetJudgingSecondRoundDetailsListActionTypes>) {
    dispatch(getJudgingSecondRoundDetailsListLoadingAction(true));
    axios
      .post(
        Url.baseUrl +
          `/competitionapp/api/competitionSecondRoundAsJury/get_patientDetailsList_2nd_round_of_competition_as_jury`,
          competionId,
        { headers: headers },
      )
      .then((res) => {
        apiRes = res.data;
        dispatch(getJudgingSecondRoundDetailsListLoadingAction(false));
        dispatch(getJudgingSecondRoundDetailsListSuccessAction(res.data));
      })
      .catch((error) => {
        dispatch(getJudgingSecondRoundDetailsListLoadingAction(false));
        dispatch(
          getJudgingSecondRoundDetailsListErrorAction(
            {} as GetJudgingSecondRoundDetailsListDetails,
            error.response !== undefined
              ? error.response.data.message
              : "Something went wrong!",
            error.status !== undefined ? error.response.data.status || -1 : -1,
          ),
        );
      });
  };
};

export const getJudgingSecondRoundDetailsListAPIResMsg = () => {
  return function (dispatch: Dispatch<GetJudgingSecondRoundDetailsListActionTypes>) {
    dispatch(
      getJudgingSecondRoundDetailsListAPIMsgAction(apiRes as GetJudgingSecondRoundDetailsListDetails, "", 0),
    );
  };
};

export const clearGetJudgingSecondRoundDetailsListAPIRes = () => {
  return function (dispatch: Dispatch<GetJudgingSecondRoundDetailsListActionTypes>) {
    dispatch(
      getJudgingSecondRoundDetailsListAPIResClearAction({} as GetJudgingSecondRoundDetailsListDetails, "", 0),
    );
  };
};
